import React from "react";
import Navbar from "../headers_footer/navbar";
import Flexproducts from "./flexproducts";
import Header from "../headers_footer/header";

const Haircare = () => {

return (

<div>

<Navbar />
<Flexproducts type="haircare" />
<Header></Header>

</div>

);
};

export default Haircare;